import { render, staticRenderFns } from "./AppApontamentos.vue?vue&type=template&id=2b616163&scoped=true&"
import script from "./AppApontamentos.vue?vue&type=script&lang=js&"
export * from "./AppApontamentos.vue?vue&type=script&lang=js&"
import style0 from "./AppApontamentos.vue?vue&type=style&index=0&id=2b616163&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b616163",
  null
  
)

export default component.exports